import { useChat } from '@/hooks/useChat';
import { HeroSection } from '@/components/landing/HeroSection';
import { MessageList } from './MessageList';
import { ChatInput } from './ChatInput';

export function ChatContainer() {
  const {
    messages,
    sendMessage,
    isStreaming,
    chatState,
  } = useChat();

  const isLanding = chatState === 'landing';

  return (
    <div className="flex flex-col h-full">
      {/* Hero / collapsed banner */}
      <HeroSection collapsed={!isLanding} onStarterSelect={sendMessage} />

      {/* Chat area - grows when active */}
      {!isLanding && (
        <div className="flex-1 flex flex-col min-h-0 bg-white">
          <div className="flex-1 overflow-hidden max-w-3xl w-full mx-auto flex flex-col">
            <MessageList
              messages={messages}
              isStreaming={isStreaming}
              onSendMessage={sendMessage}
            />
          </div>
        </div>
      )}

      {/* Input - always visible */}
      <div className={`${isLanding ? 'absolute bottom-12 md:bottom-16 left-0 right-0' : ''}`}>
        <div className={isLanding ? 'max-w-2xl mx-auto px-4' : ''}>
          <ChatInput onSend={sendMessage} disabled={isStreaming} />
        </div>
      </div>
    </div>
  );
}
